/* 甘寧傳・第 4 章：益陽・關羽瀨（建安二十年，215）
 * 史實：〈甘寧傳〉正文：「後隨魯肅鎮益陽，拒關羽。羽號有三萬人，自擇選銳士五千人，投縣上流十餘里淺瀨，云欲夜涉渡。
 *       肅與諸將議。寧時有三百兵，乃曰：『可復以五百人益吾，吾往對之，保羽聞吾欬唾，不敢涉水，涉水即是吾禽。』
 *       肅便選千兵益寧，寧乃夜往。羽聞之，住不渡，而結柴營，今遂名此處爲關羽瀨。」
 * 流程：1. 在魯肅營中請兵：魯肅給一千人。夜裡帶著一千三百人往上游的淺瀨去。
 *       2. 關羽的銳士一隊隊試著涉水過瀨。甘寧親手在水裡殺掉的（涉水即是吾禽）最能嚇住關羽；上了南岸才殺掉的差一些，部下殺的只算一點；
 *          讓人衝過南岸的防線就會讓關羽更想渡。甘寧在岸邊站定，還能朝對岸「欬唾」（大喊）示威。
 *          關羽的「疑懼」滿了就住不渡、結柴營；拖太久關羽就親自涉水，或是讓 4 人過瀨：失敗。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, boss, hero, rout, TROOPS } from '../kit.ts';
import { chaiying } from './ganning_kit.ts';
import { FORD, LUSU, GUAN, BANK_S, LINE_S } from '../maps/ganning_yiyang.ts';

const LV = 14, LIMIT = 150, PASS = 4, SHOUT_CD = 12;
const SHU = { spec: TROOPS.shu, name: '關羽銳士', hp: 520, maxHp: 520, atk: 28, ms: 235 };
const wet = (u) => SG.MAP.waterAt(u.x, u.y);

export default {
  id: 'ganning-4', map: 'ganning_yiyang', hero: 'ganning',
  title: '第 4 章　益陽・關羽瀨', year: '建安二十年（215）',
  brief: {
    quote: [{ text: '可復以五百人益吾，吾往對之，保羽聞吾欬唾，不敢涉水，涉水即是吾禽。', src: '《三國志·吳書·甘寧傳》' }],
    text: '孫權與劉備爭荊州三郡，魯肅屯益陽拒關羽。關羽號稱三萬人，親自挑了五千銳士，要從縣城上游十餘里的淺瀨夜渡。魯肅與諸將商議，甘寧手下只有三百人。',
    goals: ['向魯肅請兵', '夜往上游的淺瀨', '嚇住關羽：讓他不敢涉水'],
  },
  words: { ally: '吳兵', foe: '關羽銳士' },
  stars: [
    { text: '如史：涉水即是吾禽——親手在水裡斬殺 8 人以上', ok: (m) => m.vars.wetKills >= 8 },
    { text: '沒有一人過瀨', ok: (m) => m.vars.passed === 0 },
    { text: `${Math.round(LIMIT * 0.6)} 秒內讓關羽住不渡`, ok: (m) => m.vars.stopT != null && m.vars.stopT <= LIMIT * 0.6 },
  ],
  steps: [
    { // 1. 魯肅營中請兵
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        V.ls = ally(w, 'lusu', LUSU[0] - 250, LUSU[1] - 150, LV); V.ls.hold = [V.ls.x, V.ls.y];
        V.men = Array.from({ length: 3 }, (_, i) => { const u = m.recruit(me.x - 90 - i * 50, me.y + 60, '吳兵'); m.join(u, me); return u; });
        m.mark('ls', V.ls.x, V.ls.y, '魯肅');
        m.obj('ask', '到魯肅帳前請兵');
        m.line('魯肅', '關羽挑了五千銳士，要從上游淺瀨夜渡。諸君有何計？');
      },
      tick(m, w) { return m.near(w.player, m.vars.ls.x, m.vars.ls.y, 220); },
    },
    { // 2. 夜往淺瀨
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('ask'); m.unmark('ls');
        m.line('甘寧', '可復以五百人益吾，吾往對之，保羽聞吾欬唾，不敢涉水，涉水即是吾禽！');
        m.after(4, () => {
          m.card('肅便選千兵益寧，寧乃夜往。', '《甘寧傳》');
          for (let i = 0; i < 10; i++) { const u = m.recruit(me.x + 80 + (i % 5) * 45, me.y + 80 + Math.floor(i / 5) * 70, '吳兵'); m.join(u, me); V.men.push(u); }
        });
        m.mark('ford', FORD[0], BANK_S + 80, '淺瀨');
        m.obj('go', '夜往上游的淺瀨');
      },
      tick(m, w) { return m.near(w.player, FORD[0], BANK_S + 80, 300); },
    },
    { // 3. 對瀨：嚇住關羽
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('go'); m.unmark('ford');
        V.t0 = w.t; V.fear = 0; V.passed = 0; V.wetKills = 0; V.waveT = 3; V.foes = []; V.shoutT = 0;
        V.gy = boss(w, hero('guanyu'), GUAN[0], GUAN[1] + 450, { name: '關羽', hp: 9000, atk: 95, armor: 12, ms: 240, untargetable: true });
        V.gy.home = [GUAN[0], GUAN[1] + 450];
        m.mark('gy', V.gy.x, V.gy.y, '關羽', false, V.gy);
        m.line('關羽', '吳人只有區區數百，今夜便渡！');
        m.after(3, () => m.line('提示', '關羽的銳士會一隊隊涉水過瀨。甘寧親手在水裡殺掉的最能嚇住關羽（甘寧在水裡時 Q 錦帆打到的都會擊飛）；站在南岸邊不動，甘寧會朝對岸「欬唾」示威。'));
        m.obj('fear', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, t = w.t - V.t0;
        // 一隊隊涉水：從北岸下水，目標是南岸後面的大路
        V.waveT -= dt;
        if (V.waveT <= 0) {
          V.waveT = 11; V.wave = (V.wave || 0) + 1;
          for (let i = 0; i < 3 + Math.min(3, Math.floor(V.wave / 2)); i++) { const u = m.foe('huangjin', FORD[0] - 160 + i * 80, FORD[1] - 420, SHU); u.home = [FORD[0] + (i % 3 - 1) * 200, LINE_S + 200]; V.foes.push(u); }
        }
        for (const u of V.foes) {
          if (!u.alive) {
            if (u.counted2) continue;
            u.counted2 = true;
            const k = u.lastKiller && (u.lastKiller.owner || u.lastKiller), mine = k === me; // 甘寧親手殺的才嚇得住關羽
            V.fear += mine ? (u.diedWet ? 7 : 3) : 1;
            if (mine && u.diedWet) V.wetKills++;
            continue;
          }
          u.diedWet = wet(u);
          if (!(u.target && u.target.alive)) u.home = [u.home[0], LINE_S + 200];
          if (u.y > LINE_S && !u.passed) { u.passed = true; V.passed++; V.fear = Math.max(0, V.fear - 10); m.line('吳兵', '有人衝過去了！'); u.alive = false; u.counted = true; u.counted2 = true; }
        }
        // 欬唾：甘寧在南岸邊站定、附近沒有敵人，朝對岸大喊
        V.shoutT -= dt;
        const foeNear = V.foes.some((u) => u.alive && SG.gd(u.x, u.y, me.x, me.y) < 450);
        if (V.shoutT <= 0 && !me.chan && !foeNear && Math.abs(me.x - FORD[0]) < 600 && me.y > BANK_S - 260 && me.y < BANK_S + 260 && m.idle(me)) m.chan(me, 1.5, '欬唾', () => {
          V.shoutT = SHOUT_CD; V.fear += 6; V.shouts = (V.shouts || 0) + 1;
          m.line('甘寧', ['關雲長！甘興霸在此，你敢涉水嗎？', '涉水即是吾禽！', '五千銳士？來一個殺一個！'][V.shouts % 3]);
          w.fx({ k: 'spark', x: me.x, y: me.y - 60, col: '#ffe28a' });
        });
        V.fear = Math.min(100, V.fear);
        m.get('fear').text = `關羽的疑懼：${Math.round(V.fear)}%　過瀨 ${V.passed}/${PASS}（${Math.max(0, Math.ceil(LIMIT - t))} 秒後關羽親渡）`;
        if (V.passed >= PASS) { m.lose('關羽的銳士過了淺瀨'); return false; }
        if (t > LIMIT) { m.lose('關羽親自率銳士涉水夜渡'); return false; }
        if (V.fear >= 100) { V.stopT = t; return true; }
        return false;
      },
    },
    { // 4. 住不渡，而結柴營
      enter(m, w) {
        const V = m.vars;
        m.done('fear'); m.unmark('gy');
        rout(m, w, V.foes, [GUAN[0], GUAN[1] - 200]);
        m.big('關羽住不渡！');
        m.card('羽聞之，住不渡，而結柴營。', '《甘寧傳》');
        for (const [dx, dy] of [[-380, 520], [0, 600], [380, 520]]) m.folk(GUAN[0] + dx, GUAN[1] + dy, { name: '柴營', still: true, near: 1, draw: chaiying });
        m.after(4, () => m.card('今遂名此處爲關羽瀨。權嘉寧功，拜西陵太守，領陽新、下雉兩縣。', '《甘寧傳》'));
        m.after(9, () => m.card('後曹公出濡須，寧百騎夜入魏營，北軍驚駭。孫權曰：「孟德有張遼，孤有興霸，足相敵也。」建安二十年從攻合肥，張遼奄至，寧引弓射敵，厲聲問鼓吹何以不作。寧卒，權痛惜之。', '《甘寧傳》及注引《江表傳》'));
        m.after(15, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) m.lose('甘寧陣亡');
  },
};
